<template>
  <div class="sip-collapse">
    <div class="sip-collapse__main">
      <div class="sip-collapse__item">
        <span class="sip-collapse__name">{{ this.$t('pbx.sip-account.form.field.login') }}:</span>
        <tooltip :content="$t('shared.component.v-copy.copy')" placement="right" trigger="hover">
          <span class="sip-collapse__value copy-row" @click="copy(item.login)">{{ item.login }}<icon type="md-copy" size="20" /></span>
        </tooltip>
      </div>

      <b-collapse id="collapse" v-model="is_collapse" class="sip-collapse__content">
        <div class="sip-collapse__item">
          <span class="sip-collapse__name">
            {{ this.$t('pbx.sip-account.form.field.host') }}:
          </span>

          <tooltip :content="$t('shared.component.v-copy.copy')" placement="right" trigger="hover">
            <span class="sip-collapse__value copy-row" @click="copy(item.pbx_host)">{{
              item.pbx_host
            }}<icon type="md-copy" size="20" /></span>
          </tooltip>
        </div>
        <div class="sip-collapse__item">
          <span class="sip-collapse__name">
            {{ this.$t('pbx.sip-account.form.field.password') }}:
          </span>
          <tooltip :content="$t('shared.component.v-copy.copy')" placement="right" trigger="hover">
            <span class="sip-collapse__value copy-row" @click="copy(item.password)">{{
              item.password
            }}<icon type="md-copy" size="20" /></span>
          </tooltip>
        </div>
      </b-collapse>
    </div>

    <div class="sip-collapse__controls">
      <icon
        :type="!is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'"
        class="sip-collapse__controls-icon"
        @click="is_collapse = !is_collapse"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      is_collapse: false
    }),

    methods: {
      copy: function (value) {
        this.$copyText(value).then(() => {
          this.$noty.success(this.$t('shared.component.noty.text_copied'));
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .sip-collapse {
    display: flex;
    width: 100%;

    &__main {
      flex: auto;
    }

    &__controls {
      margin-left: 15px;
      align-self: center;
    }

    &__controls-icon {
      font-size: 18px;

      &:hover {
        cursor: pointer;
      }
    }

    &__content {
      .sip-collapse__item {
        margin-top: 10px;
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
    }

    &__name {
      color: #a0a0a0;
    }
  }
</style>
